// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SignOutButton_wrapper__AqZRx","label":"SignOutButton_label__GrF2A","icon":"SignOutButton_icon__kFZUz"};